export default __webpack_public_path__ + "static/1-56de2bf806aff0bc85f612c70e2147ed.jpg";